// extracted by mini-css-extract-plugin
export default {"pill":"Pill_pill__5l343","pillError":"Pill_pillError__DxcNo","pillWarning":"Pill_pillWarning__WQ6d5"};